import { network } from 'services/network';
import { useQuery } from 'react-query';

const queryFn = () => {
    return network.get('admin/bo/getVersion').then((response) => response.data);
};
export const useQueryApiVersion = () => {
    return useQuery({ queryKey: ['ApiVersion'], queryFn });
};
